


  <div class="container-fluid w-100 col-panel-wrapper" style="height: calc(100vh - 185px);">
    <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
         [ngClass]="{'expanded': colPanelOpen}">
      <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
        <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
      </div>
      <div class="col-panel-content">
        <h6 class="col-panel-title mb-2">Columnas</h6>
        <div class="col-panel-option" *ngFor="let column of tableColumns">
          <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id)" [color]="'primary'">{{column.name}}</mat-checkbox>
        </div>
        <mat-divider style="margin: 6px 0;"></mat-divider>
        <div class="col-panel-option" *ngFor="let column2 of tableColumnsLat">
          <mat-checkbox [checked]="column2.isShow" (change)="toggleColumnLatVisibility(column2.id)" [color]="'primary'">{{column2.name}}</mat-checkbox>
        </div>
      </div>
    </div>
    <div class="scroll-date" *ngIf="currentDate">{{ currentDate | smartDate }}</div>
    <div class="resizable-column border-botton mb-1" #fila1 id="fila1" (mousedown)="startResizing($event, fila1)" >
      <cdk-virtual-scroll-viewport [appendOnly]="false"  [tvsItemSize]="24" [headerHeight]="34"  #viewportLiqVal class="wrapper mat-elevation-z2 tableStyle" *ngIf="modelo"  (scrolledIndexChange)="mostrarFechaScroll($event)">
        <table cdk-table [dataSource]="liqval" class="table-striped tableStyle">

          <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
          <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"  [ngClass]="{'selected': row === filaSeleccionada}"></tr>
          <ng-container *ngFor="let tablecol of tableColumns">

            <ng-container [cdkColumnDef]="tablecol.id">
              <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
                {{tablecol.name}}
              </th>
              <td cdk-cell *cdkCellDef="let item" [ngClass]="{
                                              'salida': item[tablecol.id] === 'SALIDA',
                                              'entrada': item[tablecol.id] === 'ENTRADA',
                                              'numero-positivo': item[tablecol.id] > 0,
                                              'numero-negativo': item[tablecol.id] < 0
                                              }">
                <ng-container *ngIf="tablecol.isString">
                  {{item[tablecol.id]}}
                </ng-container>
                <ng-container *ngIf="tablecol.isDate">
                  {{item[tablecol.id] | smartDate}}
                </ng-container>
                <ng-container *ngIf="tablecol.isNumber">
                  {{item[tablecol.id] |number:'1.2-2'}}
                </ng-container>
              </td>
            </ng-container>
          </ng-container>
        </table>
      </cdk-virtual-scroll-viewport>

      <cdk-virtual-scroll-viewport [appendOnly]="false"  [tvsItemSize]="24" [headerHeight]="34"  #viewportLiqValDiv class="wrapper mat-elevation-z2 tableStyle" *ngIf="isPlanificador"  (scrolledIndexChange)="mostrarFechaScroll($event)">
        <table cdk-table [dataSource]="Divliqval" class="table-striped tableStyle">

          <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
          <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"  [ngClass]="{'selected': row === filaSeleccionada}"></tr>
          <ng-container *ngFor="let tablecol of tableColumns">

            <ng-container [cdkColumnDef]="tablecol.id">
              <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
                {{tablecol.name}}
              </th>
              <td cdk-cell *cdkCellDef="let item" [ngClass]="{
                                              'salida': item[tablecol.id] === 'SALIDA',
                                              'entrada': item[tablecol.id] === 'ENTRADA',
                                              'numero-positivo': item[tablecol.id] > 0,
                                              'numero-negativo': item[tablecol.id] < 0
                                              }">
                <ng-container *ngIf="tablecol.isString">
                  {{item[tablecol.id]}}
                </ng-container>
                <ng-container *ngIf="tablecol.isDate">
                  {{item[tablecol.id] | smartDate}}
                </ng-container>
                <ng-container *ngIf="tablecol.isNumber">
                  {{item[tablecol.id] |number:'1.2-2'}}
                </ng-container>
              </td>
            </ng-container>
          </ng-container>
        </table>
      </cdk-virtual-scroll-viewport>
      <!-- ------------------------- GESTOR ---------------------- -->
      <cdk-virtual-scroll-viewport [appendOnly]="false"  [tvsItemSize]="24" [headerHeight]="34"  #viewportLiqValGest class="wrapper mat-elevation-z2 tableStyle" *ngIf="isGestion"  (scrolledIndexChange)="mostrarFechaScroll($event)">
        <table cdk-table [dataSource]="gestLiqval" class="table-striped tableStyle">

          <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
          <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"  [ngClass]="{'selected': row === filaSeleccionada}"></tr>
          <ng-container *ngFor="let tablecol of tableColumns">

            <ng-container [cdkColumnDef]="tablecol.id">
              <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
                {{tablecol.name}}
              </th>
              <td cdk-cell *cdkCellDef="let item" [ngClass]="{
                                              'salida': item[tablecol.id] === 'SALIDA',
                                              'entrada': item[tablecol.id] === 'ENTRADA',
                                              'numero-positivo': item[tablecol.id] > 0,
                                              'numero-negativo': item[tablecol.id] < 0
                                              }">
                <ng-container *ngIf="tablecol.isString">
                  {{item[tablecol.id]}}
                </ng-container>
                <ng-container *ngIf="tablecol.isDate">
                  {{item[tablecol.id] | smartDate}}
                </ng-container>
                <ng-container *ngIf="tablecol.isNumber">
                  {{item[tablecol.id] |number:'1.2-2'}}
                </ng-container>
              </td>
            </ng-container>
          </ng-container>
        </table>
      </cdk-virtual-scroll-viewport>
      <!-- --------------------------------- BROKER ----------------------- -->
      <cdk-virtual-scroll-viewport [appendOnly]="false"  [tvsItemSize]="24" [headerHeight]="34"  #viewportLiqValGest class="wrapper2 mat-elevation-z2 tableStyle" *ngIf="isBroker"  (scrolledIndexChange)="mostrarFechaScroll($event)">
        <table cdk-table [dataSource]="brokLiqval" class="table-striped tableStyle">

          <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
          <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"  [ngClass]="{'selected': row === filaSeleccionada}"></tr>
          <ng-container *ngFor="let tablecol of tableColumns">

            <ng-container [cdkColumnDef]="tablecol.id">
              <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
                {{tablecol.name}}
              </th>
              <td cdk-cell *cdkCellDef="let item" [ngClass]="{
                                              'salida': item[tablecol.id] === 'SALIDA',
                                              'entrada': item[tablecol.id] === 'ENTRADA',
                                              'numero-positivo': item[tablecol.id] > 0,
                                              'numero-negativo': item[tablecol.id] < 0
                                              }">
                <ng-container *ngIf="tablecol.isString">
                  {{item[tablecol.id]}}
                </ng-container>
                <ng-container *ngIf="tablecol.isDate">
                  {{item[tablecol.id] | smartDate}}
                </ng-container>
                <ng-container *ngIf="tablecol.isNumber">
                  {{item[tablecol.id] |number:'1.2-2'}}
                </ng-container>
              </td>
            </ng-container>
          </ng-container>
        </table>
      </cdk-virtual-scroll-viewport>
    </div>

    <div class="resizable-column " #fila2 id="fila2" (mousedown)="startResizing($event, fila2)">
      <app-vallatentes [selectedTab]="selectedTab" [tableColumnsLat]="tableColumnsLat" 
                        [modelo]="modelo"
                        [isPlanificador]="isPlanificador"
                        [displayedColumnsLat]="displayedColumnsLat"
                        [isGestion]="isGestion"
                        [isBroker]="isBroker" >
    </app-vallatentes>
    </div>
  </div>
  <div class="spinner-container" *ngIf="loading">
    <mat-spinner diameter="100"></mat-spinner>
  </div>
